import { push } from 'connected-react-router'

export const loadPackagesBySupplierId = (supplierId, clientId) => ({
  type: 'FETCH_PACKAGES_BY_SUPPLIERID',
  payload: {
    client: 'mileageApi',
    request: {
      method: 'get',
      url: `/mileage-api/v1/packages/${supplierId}/${clientId}`
    }
  }
})

const secondFactorAuthentication = (orderId, secondFactorAuthConfirmated, phone) => ({
  type: 'SECOND_FACTOR_AUTHENTICATION',
  orderId,
  secondFactorAuthConfirmated,
  phone
})

export const redemptionFuelCredit = client => (order, state) => {
  return (dispatch, getState) => {
    const {
      oidc: { user }
    } = getState()
    if (!user) {
      dispatch(push('/auth/login'))
    } else {
      dispatch({ type: 'REDEMPTION_FUEL_CREDIT' })
    }

    const handleSuccess = response => {
      dispatch({ type: 'REDEMPTION_FUEL_CREDIT_SUCCESS' })
      dispatch(push(`services/confirmation/${response.data.order.liveOrderId}`))
    }
    const handleError = ({ response }) => {
      if
      (
        response.status === 401 && response.data.message &&
        response.data.message === '2FA Required'
      ) {
        dispatch(secondFactorAuthentication(response.data.orderId, true, response.data.phone))
      } else if (response.status === 406) {
        dispatch(secondFactorAuthentication(null, false, null))
      } else {
        dispatch({
          type: 'REDEMPTION_FUEL_CREDIT_FAIL',
          packageSelected: state.packageSelected
        })
        dispatch(push(`/fuelcredit`))
      }
    }

    client
      .post('/mileage-api/v1/orders/redemption', order, {
        headers: { 'X-Mileage-VendorId': state.shellSupplierId }
      })
      .then(handleSuccess)
      .catch(handleError)
  }
}

export const closeError = () => ({ type: 'REDEMPTION_FUEL_CREDIT_CLOSE_ERROR' })

export const changeStepFuelCredit = step => {
  return dispatch => {
    dispatch({
      type: 'CHANGE_STEP_FUEL_CREDIT',
      step
    })
  }
}

export const redirectFuelCreditError = (descriptionErrorFuelCredit, state) => {
  return dispatch => {
    dispatch({
      type: 'REDIRECT_ERROR_FUEL_CREDIT',
      descriptionErrorFuelCredit,
      packageSelected: state.packageSelected
    })
    dispatch(push(`/fuelcredit`))
  }
}

export default client => ({
  loadPackagesBySupplierId,
  redemptionFuelCredit: redemptionFuelCredit(client),
  closeError,
  changeStepFuelCredit,
  redirectFuelCreditError
})



// WEBPACK FOOTER //
// ./src/features/Services/FuelCredit/actions.js